export default {
    defaultLocale : 'he-IL',
    availableLocales: ['he-IL', 'en-US']
}
